import {importFile, MainRequest} from 'Services/common';
import Config from '../../../config';
import {download} from '../../../Utils/common';

export enum AccountType {
    'Public' = '1',
    'Subscription' = '2',
    'Video' = '3',
}
export interface GetAccount extends PaginationAntD {
    keyword: string;
    accountType: AccountType; //公众号类型：1公众号 2订阅号 3视频号
}

const _customerId = Config.IS_BIGDATA_ADMIN;

export interface AccountList {
    accountType: AccountType; //公众号类型：1公众号 2订阅号 3视频号
    nickname: string; //公众号名称
    description: string; //公众号说明
    id: string; //主键
    wechatNumber: string; //公众号微信号码
    createDate: string; //创建时间
}

//获取列表
export function getAccountPage(params?: GetAccount) {
    return MainRequest.post<PagedSuccessData<AccountList[]>>(
        '/wechatSaas/findOfficialAccountPage',
        {
            ...params,
            customerId: _customerId,
            pageNo: params?.current,
            pageSize: params?.pageSize,
        },
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                data: res.data,
                total: res.total,
            };
        });
}

//编辑
export interface SaveAccount {
    accountType: AccountType; //公众号类型：1公众号 2订阅号 3视频号
    nickname: string; //公众号名称
    description: string; //公众号说明
    id: string; //主键
    wechatNumber: string; //公众号的微信号码
}

export function editAccount(data: SaveAccount) {
    return MainRequest.post('/wechatSaas/saveOfficialAccountInfo', {
        ...data,
        customerId: _customerId,
    });
}

//删除
export function deleteAccount(id: string) {
    return MainRequest.get(`/wechatSaas/deleteOfficialAccountInfo/${id}`);
}

//下载导入模板
export function downloadTemplate() {
    return download('/wechatSaas/downloadTemplate', {method: 'get'});
}

//导入
export function importOfficialAccount(file: File) {
    return importFile('/wechatSaas/importOfficialAccount', file);
}
